'use strict';

module.exports = function (ngModule) {
    ngModule.config(require('./auth'));
}


/** WEBPACK FOOTER **
 ** ./src/auth/routes/index.js
 **/